<template>
  <!-- 编辑/供应商驳回条：总开关见 @/constants/approvalRejectUi.js -->
  <div v-if="showBanner && hasRejected" class="mrb">
    <div
      class="mrb-bar"
      data-testid="mrb-banner"
      role="button"
      tabindex="0"
      @click="openFirstRejected"
      @keydown.enter.prevent="openFirstRejected"
      @keydown.space.prevent="openFirstRejected"
    >
      <p class="mrb-label">{{ $t('lbl_EMPBE_Rejected') }}</p>
      <button
        type="button"
        class="mrb-cta"
        data-testid="mrb-cta"
        @click.stop="openFirstRejected"
      >
        <span>{{ $t('lbl_EMPBE_Uploader_ViewRejectReasonDetails') }}</span>
        <span class="material-symbols-outlined mrb-cta-icon" aria-hidden="true">keyboard_arrow_right</span>
      </button>
    </div>

    <MediaPreviewPopover
      :visible="popoverOpen"
      mode="customer"
      :media-type="activeMediaType"
      :media="activeMedia"
      :reject-reason="activeRejectReason"
      :rejected="true"
      :templates="[]"
      :actor="activeActor"
      :show-prev="canGoPrev"
      :show-next="canGoNext"
      @close="closePopover"
      @prev="goPrev"
      @next="goNext"
    />
  </div>
</template>

<script>
import MediaPreviewPopover from './mediaPreviewPopover.vue';
import { SHOW_EDIT_SUPPLIER_REJECT_REASON, shouldShowEditSupplierRejectPanels } from '@/constants/approvalRejectUi.js';

function isNonEmptyReason(value) {
  return String(value == null ? '' : value).trim() !== '';
}

export default {
  name: 'MediaRejectBanner',
  components: {
    MediaPreviewPopover,
  },
  inject: {
    productApprovalHost: { default: null },
    companyApprovalHost: { default: null },
  },
  props: {
    records: { type: Array, default: () => [] },
  },
  data() {
    return {
      popoverOpen: false,
      activeRejectedIndex: -1,
    };
  },
  computed: {
    approvalHost() {
      return this.productApprovalHost || this.companyApprovalHost || null;
    },
    showBanner() {
      if (!SHOW_EDIT_SUPPLIER_REJECT_REASON) return false;
      // 无 host（组件 Playground）：仍按 records 展示
      if (!this.approvalHost) return true;
      return shouldShowEditSupplierRejectPanels(this.approvalHost);
    },
    rejectedRecords() {
      return (this.records || []).filter((record) => isNonEmptyReason(record && record.rejectReason));
    },
    hasRejected() {
      return this.rejectedRecords.length > 0;
    },
    activeRecord() {
      if (this.activeRejectedIndex < 0) return null;
      return this.rejectedRecords[this.activeRejectedIndex] || null;
    },
    activeMedia() {
      if (!this.activeRecord) return null;
      return {
        previewSrc: this.activeRecord.previewSrc || '',
        fileName: this.activeRecord.fileName || '',
      };
    },
    activeMediaType() {
      return this.activeRecord && this.activeRecord.mediaType === 'video' ? 'video' : 'image';
    },
    activeRejectReason() {
      return this.activeRecord ? String(this.activeRecord.rejectReason) : '';
    },
    activeActor() {
      return (this.activeRecord && this.activeRecord.actor) || '';
    },
    canGoPrev() {
      return this.activeRejectedIndex > 0;
    },
    canGoNext() {
      return this.activeRejectedIndex >= 0 && this.activeRejectedIndex < this.rejectedRecords.length - 1;
    },
  },
  methods: {
    openFirstRejected() {
      if (!this.hasRejected) return;
      this.activeRejectedIndex = 0;
      this.popoverOpen = true;
    },
    closePopover() {
      this.popoverOpen = false;
      this.activeRejectedIndex = -1;
    },
    goPrev() {
      if (!this.canGoPrev) return;
      this.activeRejectedIndex -= 1;
    },
    goNext() {
      if (!this.canGoNext) return;
      this.activeRejectedIndex += 1;
    },
  },
};
</script>

<style scoped lang="scss">
.mrb {
  width: 100%;
  margin-top: 8px;
  position: relative;
  z-index: 1;
}

.mrb-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  background: #fcebed;
  box-sizing: border-box;
  cursor: pointer;
}

.mrb-label {
  flex: 1 0 0;
  min-width: 0;
  margin: 0;
  color: #dc3545;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.mrb-cta {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.mrb-cta-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}
</style>
